import { createContext, useContext, useMemo } from 'react';
import createPropertySearchService from '../home.service';

const CentreSearchServiceContext = createContext();

export function CentreSearchServiceProvider({ children }) {
  const service = useMemo(() => createPropertySearchService(), []);

  return (
    <CentreSearchServiceContext.Provider value={service}>
      {children}
    </CentreSearchServiceContext.Provider>
  );
}

export function useCentreSearchService() {
  const context = useContext(CentreSearchServiceContext);
  if (context === undefined) {
    throw new Error('useCentreSearchService must be used within a CentreSearchServiceProvider');
  }
  return context;
}

export default CentreSearchServiceContext;
